import {Entity} from "../../core/commons/entity";
import {Address} from "./address";
import {Phone} from "./phone";
import {CurriculumVitae} from "./curriculumVitae";
import {User} from "../../core/domain/user";
import {MinistryArea} from "./ministry/ministry-area";
import {AreaOfInterest} from "./area-of-interest";
import {Ministry} from "./ministry/ministry";
/**
 * Created by Federico on 13/03/2017.
 */

export class Profile implements Entity {
    public id: number = null;
    public firstname: string = "";
    public lastname: string = "";
    public birthDate: number = Date.now();
    public dni: number = null;
    public phones: Array<Phone> = [];
    public areaOfInterest : AreaOfInterest = null;
    public ministry : Ministry = null;
    public address: Address = null;
    public workPhone: Phone = new Phone();
    public profilePhoto: string = "";
    public backgroundPhoto: string = "";


    constructor(value: Object = {}) {
        Object.assign(this, value);
        this.address = this.address ? new Address(this.address) : new Address();
        this.ministry = this.ministry ? new Ministry(this.ministry): null;
        this.areaOfInterest = this.areaOfInterest ? new AreaOfInterest(this.areaOfInterest): null;
        this.phones = this.phones ? this.phones.map(phone => new Phone(phone)) : [];
        if(this.workPhone) this.workPhone = new Phone(this.workPhone);

    }

}




// WEBPACK FOOTER //
// ./src/app/profile/domain/profile.ts